const normalizeDates = (dates = []) => Array.from(new Set(
  (Array.isArray(dates) ? dates : []).filter(Boolean)
))
  .sort((left, right) => new Date(right) - new Date(left))
  .slice(0, 5)

const getTypeDates = (imageSelections = {}, landId, type) =>
  normalizeDates(imageSelections?.[landId]?.[type])

const sameDates = (left = [], right = []) => {
  const normalizedLeft = [...normalizeDates(left)].sort()
  const normalizedRight = [...normalizeDates(right)].sort()

  return normalizedLeft.length === normalizedRight.length &&
    normalizedLeft.every((dateValue, index) => dateValue === normalizedRight[index])
}

export const areImageTypeDatesAppliedToAllLands = ({
  availableDatesByLand = {},
  imageSelections = {},
  landIds = [],
  sourceLandId,
  type,
}) => {
  const sourceDates = getTypeDates(imageSelections, sourceLandId, type)

  return sourceDates.length > 0 && landIds.every((landId) => {
    const availableDates = availableDatesByLand[landId]
    const expectedDates = Array.isArray(availableDates)
      ? sourceDates.filter((dateValue) => availableDates.includes(dateValue))
      : sourceDates

    return sameDates(getTypeDates(imageSelections, landId, type), expectedDates)
  })
}

export const applyImageTypeDatesToAllLands = ({
  availableDatesByLand = {},
  imageSelections = {},
  landIds = [],
  remove = false,
  sourceLandId,
  type,
}) => {
  const sourceDates = getTypeDates(imageSelections, sourceLandId, type)

  if (!type || sourceDates.length < 1) {
    return imageSelections
  }

  const sourceDateSet = new Set(sourceDates)
  let changed = false
  const next = {...imageSelections}

  landIds.forEach((landId) => {
    const landSelections = imageSelections[landId] || {}
    const currentDates = getTypeDates(imageSelections, landId, type)
    const availableDates = availableDatesByLand[landId]
    const nextDates = remove
      ? currentDates.filter((dateValue) => !sourceDateSet.has(dateValue))
      : Array.isArray(availableDates)
        ? sourceDates.filter((dateValue) => availableDates.includes(dateValue))
        : [...sourceDates]

    if (sameDates(currentDates, nextDates)) {
      return
    }

    next[landId] = {
      ...landSelections,
      [type]: nextDates,
    }
    changed = true
  })

  return changed ? next : imageSelections
}

export const copyImageTypeDatesForLand = ({
  imageSelections = {},
  landId,
  sourceType,
  targetType,
}) => {
  if (!landId || !sourceType || !targetType || sourceType === targetType) {
    return imageSelections
  }

  const sourceDates = getTypeDates(imageSelections, landId, sourceType)
  const currentDates = getTypeDates(imageSelections, landId, targetType)

  if (sameDates(currentDates, sourceDates)) {
    return imageSelections
  }

  return {
    ...imageSelections,
    [landId]: {
      ...(imageSelections[landId] || {}),
      [targetType]: sourceDates,
    },
  }
}
